<template>
	<div class="information_container">
		<div class="information">
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<input v-if="orderType==1&&e==0" @focus="getFocus" ref="inputFocus" v-model="name" type="" name="" placeholder="请填写领队人姓名" id="" value="" />
				<input v-else="" @focus="getFocus" ref="inputFocus" v-model="name" type="" name="" placeholder="请填写姓名" id="" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/sfz.png" />
				</div>
				<!-- <input readonly="readonly" style="color: #b1b1b1;" @focus="getFocus" ref="inputFocus" v-model="documentText" type="" name="" id="" value="" /> -->
			<select name="documentType"  v-model="documentText">
					<option value="请选择证件类型">请选择证件类型</option>
					<option value="中国大陆身份证">中国大陆身份证</option>
					<option value="港澳居民来往内地通行证">港澳居民来往内地通行证</option>
					<option value="台湾居民来往大陆通行证">台湾居民来往大陆通行证</option>
					<option value="护照">护照</option>
				</select>
				<img src="../assets/toBottom.png" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sfz" src="../assets/sfz.png" />
				</div>
				<input v-if="orderType==1&&e==0" @focus="getFocus" ref="inputFocus" v-model="IdNumber" type="" name="" placeholder="请填写领队人证件号" id="" value="" />
				<input v-else="" @focus="getFocus" ref="inputFocus" v-model="IdNumber" type="" name="" placeholder="请填写证件号" id="" value="" />
			</div>
			<div v-if="orderType==1&&e==0" class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/sjh.png" />
				</div>
				<input @focus="getFocus" maxlength="11" ref="inputFocus" v-model="phone" type="number" name="" placeholder="请填写领队人手机号" id="" value="" />
			</div>
			<div v-if="orderType==0" class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/sjh.png" />
				</div>
				<input @focus="getFocus" maxlength="11" ref="inputFocus" v-model="phone" type="" name="" placeholder="请填写手机号" id="" value="" />
			</div>
			<div class="information_div" v-if="orderType==0">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<select name="documentType" v-model="childnum" @change="childInformation">
					<option value="请选择携带儿童数量">请选择携带儿童数量</option>
					<option value="0">0</option>
					<option value="1">1</option>
					<option value="2">2</option>
				</select>
				<img src="../assets/toBottom.png" />
			</div>
		</div>
		<div v-if="childnum>0" class="information_child">
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<input ref="inputFocus" v-model="childIdNumberNameOne" type="" name="" placeholder="请填写儿童姓名" id="" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/sjh.png" />
				</div>
				<input ref="inputFocus" v-model="childIdNumberOne" type="" name="" placeholder="请填写儿童身份证号" id="" value="" />
			</div>
		</div>
		<div v-if="childnum>1" class="information_child">
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_gr" src="../assets/personal.png" />
				</div>
				<input ref="inputFocus" v-model="childIdNumberNameTwo" type="" name="" placeholder="请填写儿童姓名" id="" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/sjh.png" />
				</div>
				<input ref="inputFocus" v-model="childIdNumberTwo" type="" name="" placeholder="请填写儿童身份证号" id="" value="" />
			</div>
		</div>
		<div class="fill_btn_bottom" v-show="showBtn">
			<div class="buttom_bc" @click="buttombc">
				保存
			</div>
		</div>
		<div class="yin_ts" v-if="yin">
			<div class="buttom_x"><img src="../assets/buttom_x.png" /></div>
			<div class="text">{{yin_text}}</div>
			<div class="buttom_text" @click="modify">去修改</div>
		</div>
		<div class='view_yinyin' v-if="yin" catchtouchmove="return" @click="modify"></div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Information',
		data() {
			return {
				documentText:'',
				yin: false,
				name: "",
				IdNumber: "",
				phone: "",
				taid: '',
				orderid: "",
				yin_text: "",
				site_name: "",
				baseUrl: "",
				name_reg: "",
				IdNumber_reg: "",
				e: "",
				ticketcodelist: "",
				paragraphid: "",
				appointmenttime: "",
				childnum: '请选择携带儿童数量',
				childIdNumberOne: '',
				childIdNumberTwo: '',
				orderType: '',
				phoneReg: '',
				childIdNumberNameOne: "",
				childIdNumberNameTwo: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true
			}
		},
		methods: {
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			childInformation() {
				var that = this;
				if(that.childnum == '请选择携带儿童数量') {
					that.childnum == '请选择携带儿童数量'
				} else {
					that.childnum = parseInt(that.childnum);
				}
			},
			validIdCard(value) {
				var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子 
				var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; //校验码 
				if (/^\d{17}\d|x$/i.test(value)) {
					var sum = 0,
						idx;
					for (var i = 0; i < value.length - 1; i++) {
						// 对前17位数字与权值乘积求和 
						sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
					}
					// 计算模（固定算法） 
					idx = sum % 11;
					// 检验第18为是否与校验码相等 
					return arrValid[idx] == value.substr(17, 1).toUpperCase();
				} else {
					return false;
				}
			},
			buttombc() {
				var that = this;
				that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
				console.log(that.IdNumber)
				console.log(that.documentText)
				that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
								if(that.documentText == "中国大陆身份证") {
									that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
									that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
									var certificate_type = 'idcard';
								} else if(that.documentText == "护照") {
									that.name_reg = /^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z\.\s]{1,20})$/;
									that.IdNumber_reg = /^([a-zA-z]|[0-9]){5,17}$/;
									var certificate_type = 'passport';
								} else if(that.documentText == "港澳居民来往内地通行证") {
									var certificate_type = 'HK_MO_idcard';
									that.name_reg = /^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z\.\s]{1,20})$/;
									that.IdNumber_reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
								} else if(that.documentText == "台湾居民来往大陆通行证") {
									var certificate_type = 'TWN_idcard';
									that.name_reg = /^([\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z\.\s]{1,20})$/;
									that.IdNumber_reg =/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
								} else if(that.documentText == "请选择证件类型") {
									var certificate_type = 'idcard';
									that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
									that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
								}
		
		console.log(that.orderType)
				if(that.orderType == '0') {
					if(that.childnum == "请选择携带儿童数量") {
						that.childnum = 0
					}
					that.orderid = sessionStorage.getItem("orderid");
					that.site_name = sessionStorage.getItem("site_name");
					if(!that.name_reg.test(that.name)) {
						console.log('12')
						that.yin = true;
						that.yin_text = '姓名认证错误';
					} else if(that.documentText == "港澳居民来往内地通行证"&&!/^([A-Z]\d{6,10}(\(\w{1}\))?)$/.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "台湾居民来往大陆通行证"&& !/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "护照"&&!that.IdNumber_reg.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "中国大陆身份证"&&!that.validIdCard(that.IdNumber)) {
						console.log('12')
						that.yin = true;
						that.yin_text = '请输入正确的18位身份证号（不包含特殊字符、汉字,X需大写）';
					} else if(!that.phoneReg.test(that.phone)) {
						that.yin = true;
						that.yin_text = '手机号认证错误';
					} else {
						if(that.childnum == 0) {
							that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.name + '&idcard=' + that.IdNumber + '&appointmenttime=' + that.appointmenttime, {

								})
								.then(function(res) {
									if(res.data.code == 'A00001') {
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
										return
									}
									if(res.data.isbook == 1) {
										that.yin = true;
										that.yin_text = '您已预约当天的票';
									} else if(res.data.userstatus == 1) {
										that.yin = true;
										that.yin_text = '该用户为黑名单';
									} else {
										if(that.ticketcodelist[0].idcard == '') {
											var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
											that.ticketcodelist = codelist;
											that.ticketcodelist[that.e].realname = that.name;
											that.ticketcodelist[that.e].idcard = that.IdNumber;
											that.ticketcodelist[that.e].userstatus = res.data.userstatus;
											that.ticketcodelist[that.e].telnum = that.phone;
											that.ticketcodelist[that.e].certificate_type = certificate_type;
											that.ticketcodelist[that.e].childnum = that.childnum;
											that.ticketcodelist[that.e].childidcard = [];
											sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
											that.$router.push({
												name: 'FillInformation'
											});
										} else {
											if(that.ticketcodelist[that.e].idcard != that.IdNumber) {
												for(var i = 0; i < that.ticketcodelist.length; i++) {
													if(that.ticketcodelist[i].childidcard.length == 0) {
														if(that.ticketcodelist.idcard != '' && that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
															that.yin = true;
															that.yin_text = '您已填写信息';
															return
														} else {
															if(i == that.ticketcodelist.length - 1) {
																var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																that.ticketcodelist = codelist;
																that.ticketcodelist[that.e].realname = that.name;
																that.ticketcodelist[that.e].idcard = that.IdNumber;
																that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																that.ticketcodelist[that.e].telnum = that.phone;
																that.ticketcodelist[that.e].certificate_type = certificate_type;;
																that.ticketcodelist[that.e].childnum = that.childnum;
																that.ticketcodelist[that.e].childidcard = [];
																sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																that.$router.push({
																	name: 'FillInformation'
																});
															}
														}
													} else {
														for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
															if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																that.yin = true;
																that.yin_text = '您已填写信息';
																return
															} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																that.yin = true;
																that.yin_text = '您已填写信息';
																return
															} else {
																if(i == that.ticketcodelist.length - 1) {
																	var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																	that.ticketcodelist = codelist;
																	that.ticketcodelist[that.e].realname = that.name;
																	that.ticketcodelist[that.e].idcard = that.IdNumber;
																	that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																	that.ticketcodelist[that.e].telnum = that.phone;
																	that.ticketcodelist[that.e].certificate_type = certificate_type;;
																	that.ticketcodelist[that.e].childnum = that.childnum;
																	that.ticketcodelist[that.e].childidcard = [];
																	sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																	that.$router.push({
																		name: 'FillInformation'
																	});
																}
															}
														}
													}
												}
											} else {
												var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
												that.ticketcodelist = codelist;
												that.ticketcodelist[that.e].realname = that.name;
												that.ticketcodelist[that.e].idcard = that.IdNumber;
												that.ticketcodelist[that.e].userstatus = res.data.userstatus;
												that.ticketcodelist[that.e].telnum = that.phone;
												that.ticketcodelist[that.e].certificate_type = certificate_type;;
												that.ticketcodelist[that.e].childnum = that.childnum;
												that.ticketcodelist[that.e].childidcard = [];
												sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
												that.$router.push({
													name: 'FillInformation'
												});
											}

										}
									}

								})
								.catch(function(err) {
									console.log(err);
								});
						} else if(that.childnum == 1) {
							if(!that.name_reg.test(that.childIdNumberNameOne)) {
								that.yin = true;
								that.yin_text = '儿童姓名认证错误';
							} else if(that.childIdNumberOne.toUpperCase() == that.IdNumber.toUpperCase()) {
								that.yin = true;
								that.yin_text = '儿童身份证认证错误';
							} else if(!that.validIdCard(that.childIdNumberOne)) {
								that.yin = true;
								that.yin_text = '儿童身份证认证错误';
							} else {
								that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.name + '&idcard=' + that.IdNumber + '&appointmenttime=' + that.appointmenttime, {

									})
									.then(function(res) {
										if(res.data.code == 'A00001') {
											that.yin = true;
											that.yin_text = '系统繁忙，请稍后再试';
											return
										}
										if(res.data.isbook == 1) {
											that.yin = true;
											that.yin_text = '您已预约当天的票';
										} else if(res.data.userstatus == 1) {
											that.yin = true;
											that.yin_text = '该用户为黑名单';
										} else {
											that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.childIdNumberNameOne + '&idcard=' + that.childIdNumberOne + '&appointmenttime=' + that.appointmenttime, {

												})
												.then(function(res) {
													if(res.data.code == 'A00001') {
														that.yin = true;
														that.yin_text = '系统繁忙，请稍后再试';
														return
													}
													if(res.data.isbook == 1) {
														that.yin = true;
														that.yin_text = '您已预约当天的票';
													} else if(res.data.userstatus == 1) {
														that.yin = true;
														that.yin_text = '该用户为黑名单';
													} else {
														if(that.ticketcodelist[0].idcard == '') {
															var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
															that.ticketcodelist = codelist;
															that.ticketcodelist[that.e].realname = that.name;
															that.ticketcodelist[that.e].idcard = that.IdNumber;
															that.ticketcodelist[that.e].userstatus = res.data.userstatus;
															that.ticketcodelist[that.e].telnum = that.phone;
															that.ticketcodelist[that.e].certificate_type = certificate_type;;
															that.ticketcodelist[that.e].childnum = that.childnum;
															that.ticketcodelist[that.e].childidcard = [{
																'name': that.childIdNumberNameOne,
																'idcard': that.childIdNumberOne
															}];
															sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
															that.$router.push({
																name: 'FillInformation'
															});
														} else {
															if(that.ticketcodelist[that.e].childidcard.length == 0) {
																if(that.ticketcodelist[that.e].idcard == that.IdNumber) {
																	for(var i = 0; i < that.ticketcodelist.length; i++) {
																		if(that.ticketcodelist[i].childidcard.length == 0) {
																			if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else {
																				if(i == that.ticketcodelist.length - 1) {
																					var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																					that.ticketcodelist = codelist;
																					that.ticketcodelist[that.e].realname = that.name;
																					that.ticketcodelist[that.e].idcard = that.IdNumber;
																					that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																					that.ticketcodelist[that.e].telnum = that.phone;
																					that.ticketcodelist[that.e].certificate_type = certificate_type;;
																					that.ticketcodelist[that.e].childnum = that.childnum;
																					that.ticketcodelist[that.e].childidcard = [{
																						'name': that.childIdNumberNameOne,
																						'idcard': that.childIdNumberOne
																					}];
																					sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																					that.$router.push({
																						name: 'FillInformation'
																					});
																				}
																			}
																		} else {
																			for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																				if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else {
																					if(i == that.ticketcodelist.length - 1) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					}
																				}
																			}
																		}
																	}
																} else {
																	for(var i = 0; i < that.ticketcodelist.length; i++) {
																		if(that.ticketcodelist[i].childidcard.length == 0) {
																			if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else {
																				if(i == that.ticketcodelist.length - 1) {
																					var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																					that.ticketcodelist = codelist;
																					that.ticketcodelist[that.e].realname = that.name;
																					that.ticketcodelist[that.e].idcard = that.IdNumber;
																					that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																					that.ticketcodelist[that.e].telnum = that.phone;
																					that.ticketcodelist[that.e].certificate_type = certificate_type;;
																					that.ticketcodelist[that.e].childnum = that.childnum;
																					that.ticketcodelist[that.e].childidcard = [{
																						'name': that.childIdNumberNameOne,
																						'idcard': that.childIdNumberOne
																					}];
																					sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																					that.$router.push({
																						name: 'FillInformation'
																					});
																				}
																			}
																		} else {
																			for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																				if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else {
																					if(i == that.ticketcodelist.length - 1) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					}
																				}
																			}
																		}
																	}
																}
															} else if(that.ticketcodelist[that.e].childidcard.length == 1) {
																if(that.ticketcodelist[that.e].idcard == that.IdNumber) {
																	if(that.ticketcodelist[that.e].childidcard[0].idcard == that.childIdNumberOne) {
																		var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																		that.ticketcodelist = codelist;
																		that.ticketcodelist[that.e].realname = that.name;
																		that.ticketcodelist[that.e].idcard = that.IdNumber;
																		that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																		that.ticketcodelist[that.e].telnum = that.phone;
																		that.ticketcodelist[that.e].certificate_type = certificate_type;;
																		that.ticketcodelist[that.e].childnum = that.childnum;
																		that.ticketcodelist[that.e].childidcard = [{
																			'name': that.childIdNumberNameOne,
																			'idcard': that.childIdNumberOne
																		}];
																		sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																		that.$router.push({
																			name: 'FillInformation'
																		});
																	} else {
																		for(var i = 0; i < that.ticketcodelist.length; i++) {
																			if(that.ticketcodelist[i].childidcard.length == 0) {
																				if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else {
																					if(i == that.ticketcodelist.length - 1) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					}
																				}
																			} else {
																				for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																					if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																						that.yin = true;
																						that.yin_text = '您已填写信息';
																						return
																					} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																						that.yin = true;
																						that.yin_text = '您已填写信息';
																						return
																					} else {
																						if(i == that.ticketcodelist.length - 1) {
																							var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																							that.ticketcodelist = codelist;
																							that.ticketcodelist[that.e].realname = that.name;
																							that.ticketcodelist[that.e].idcard = that.IdNumber;
																							that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																							that.ticketcodelist[that.e].telnum = that.phone;
																							that.ticketcodelist[that.e].certificate_type = certificate_type;;
																							that.ticketcodelist[that.e].childnum = that.childnum;
																							that.ticketcodelist[that.e].childidcard = [{
																								'name': that.childIdNumberNameOne,
																								'idcard': that.childIdNumberOne
																							}];
																							sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																							that.$router.push({
																								name: 'FillInformation'
																							});
																						}
																					}
																				}
																			}
																		}
																	}
																} else {
																	for(var i = 0; i < that.ticketcodelist.length; i++) {
																		if(that.ticketcodelist[i].childidcard.length == 0) {
																			if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else {
																				if(i == that.ticketcodelist.length - 1) {
																					var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																					that.ticketcodelist = codelist;
																					that.ticketcodelist[that.e].realname = that.name;
																					that.ticketcodelist[that.e].idcard = that.IdNumber;
																					that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																					that.ticketcodelist[that.e].telnum = that.phone;
																					that.ticketcodelist[that.e].certificate_type = certificate_type;;
																					that.ticketcodelist[that.e].childnum = that.childnum;
																					that.ticketcodelist[that.e].childidcard = [{
																						'name': that.childIdNumberNameOne,
																						'idcard': that.childIdNumberOne
																					}];
																					sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																					that.$router.push({
																						name: 'FillInformation'
																					});
																				}
																			}
																		} else {
																			for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																				if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else {
																					if(i == that.ticketcodelist.length - 1) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					}
																				}
																			}
																		}
																	}
																}
															} else {
																if(that.ticketcodelist[that.e].idcard == that.IdNumber) {
																	if(that.ticketcodelist[that.e].childidcard[0].idcard == that.childIdNumberOne || that.ticketcodelist[that.e].childidcard[1].idcard == that.childIdNumberOne) {
																		var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																		that.ticketcodelist = codelist;
																		that.ticketcodelist[that.e].realname = that.name;
																		that.ticketcodelist[that.e].idcard = that.IdNumber;
																		that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																		that.ticketcodelist[that.e].telnum = that.phone;
																		that.ticketcodelist[that.e].certificate_type = certificate_type;;
																		that.ticketcodelist[that.e].childnum = that.childnum;
																		that.ticketcodelist[that.e].childidcard = [{
																			'name': that.childIdNumberNameOne,
																			'idcard': that.childIdNumberOne
																		}];
																		sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																		that.$router.push({
																			name: 'FillInformation'
																		});
																	} else {
																		for(var i = 0; i < that.ticketcodelist.length; i++) {
																			if(that.ticketcodelist[i].childidcard.length == 0) {
																				if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else {
																					if(i == that.ticketcodelist.length - 1) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					}
																				}
																			} else {
																				for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																					if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																						that.yin = true;
																						that.yin_text = '您已填写信息';
																						return
																					} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																						that.yin = true;
																						that.yin_text = '您已填写信息';
																						return
																					} else {
																						if(i == that.ticketcodelist.length - 1) {
																							var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																							that.ticketcodelist = codelist;
																							that.ticketcodelist[that.e].realname = that.name;
																							that.ticketcodelist[that.e].idcard = that.IdNumber;
																							that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																							that.ticketcodelist[that.e].telnum = that.phone;
																							that.ticketcodelist[that.e].certificate_type = certificate_type;;
																							that.ticketcodelist[that.e].childnum = that.childnum;
																							that.ticketcodelist[that.e].childidcard = [{
																								'name': that.childIdNumberNameOne,
																								'idcard': that.childIdNumberOne
																							}];
																							sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																							that.$router.push({
																								name: 'FillInformation'
																							});
																						}
																					}
																				}
																			}
																		}
																	}
																} else {
																	for(var i = 0; i < that.ticketcodelist.length; i++) {
																		if(that.ticketcodelist[i].childidcard.length == 0) {
																			if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																				that.yin = true;
																				that.yin_text = '您已填写信息';
																				return
																			} else {
																				if(i == that.ticketcodelist.length - 1) {
																					var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																					that.ticketcodelist = codelist;
																					that.ticketcodelist[that.e].realname = that.name;
																					that.ticketcodelist[that.e].idcard = that.IdNumber;
																					that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																					that.ticketcodelist[that.e].telnum = that.phone;
																					that.ticketcodelist[that.e].certificate_type = certificate_type;;
																					that.ticketcodelist[that.e].childnum = that.childnum;
																					that.ticketcodelist[that.e].childidcard = [{
																						'name': that.childIdNumberNameOne,
																						'idcard': that.childIdNumberOne
																					}];
																					sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																					that.$router.push({
																						name: 'FillInformation'
																					});
																				}
																			}
																		} else {
																			for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																				if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																					that.yin = true;
																					that.yin_text = '您已填写信息';
																					return
																				} else {
																					if(i == that.ticketcodelist.length - 1) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}

												})
												.catch(function(err) {
													console.log(err);
												});
										}

									})
									.catch(function(err) {
										console.log(err);
									});

							}
						} else if(that.childnum == 2) {
							if(!that.name_reg.test(that.childIdNumberNameOne)) {
								that.yin = true;
								that.yin_text = '儿童姓名认证错误';
							} else if(!that.name_reg.test(that.childIdNumberNameTwo)) {
								that.yin = true;
								that.yin_text = '儿童姓名认证错误';
							} else if(that.childIdNumberOne.toUpperCase() == that.IdNumber.toUpperCase()) {
								that.yin = true;
								that.yin_text = '儿童身份证认证错误';
							} else if(!that.validIdCard(that.childIdNumberOne)) {
								that.yin = true;
								that.yin_text = '儿童身份证认证错误';
							} else if(that.childIdNumberTwo.toUpperCase() == that.IdNumber.toUpperCase()) {
								that.yin = true;
								that.yin_text = '儿童身份证认证错误';
							} else if(!that.validIdCard(that.childIdNumberTwo)) {
								that.yin = true;
								that.yin_text = '儿童身份证认证错误';
							} else if(that.childIdNumberTwo.toUpperCase() == that.childIdNumberOne.toUpperCase()) {
								that.yin = true;
								that.yin_text = '儿童身份证错误';
							} else {
								that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.name + '&idcard=' + that.IdNumber + '&appointmenttime=' + that.appointmenttime, {

									})
									.then(function(res) {
										if(res.data.code == 'A00001') {
											that.yin = true;
											that.yin_text = '系统繁忙，请稍后再试';
											return
										}
										if(res.data.isbook == 1) {
											that.yin = true;
											that.yin_text = '您已预约当天的票';
										} else if(res.data.userstatus == 1) {
											that.yin = true;
											that.yin_text = '该用户为黑名单';
										} else {
											that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.childIdNumberNameOne + '&idcard=' + that.childIdNumberOne + '&appointmenttime=' + that.appointmenttime, {

												})
												.then(function(res) {
													if(res.data.code == 'A00001') {
														that.yin = true;
														that.yin_text = '系统繁忙，请稍后再试';
														return
													}
													if(res.data.isbook == 1) {
														that.yin = true;
														that.yin_text = '您已预约当天的票';
													} else if(res.data.userstatus == 1) {
														that.yin = true;
														that.yin_text = '该用户为黑名单';
													} else {
														that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.childIdNumberNameTwo + '&idcard=' + that.childIdNumberTwo + '&appointmenttime=' + that.appointmenttime, {

															})
															.then(function(res) {
																if(res.data.code == 'A00001') {
																	that.yin = true;
																	that.yin_text = '系统繁忙，请稍后再试';
																	return
																}
																if(res.data.isbook == 1) {
																	that.yin = true;
																	that.yin_text = '您已预约当天的票';
																} else if(res.data.userstatus == 1) {
																	that.yin = true;
																	that.yin_text = '该用户为黑名单';
																} else {
																	if(that.ticketcodelist[0].idcard == '') {
																		var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																		that.ticketcodelist = codelist;
																		that.ticketcodelist[that.e].realname = that.name;
																		that.ticketcodelist[that.e].idcard = that.IdNumber;
																		that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																		that.ticketcodelist[that.e].telnum = that.phone;
																		that.ticketcodelist[that.e].certificate_type = certificate_type;;
																		that.ticketcodelist[that.e].childnum = that.childnum;
																		that.ticketcodelist[that.e].childidcard = [{
																			'name': that.childIdNumberNameOne,
																			'idcard': that.childIdNumberOne
																		}, {
																			'name': that.childIdNumberNameTwo,
																			'idcard': that.childIdNumberTwo
																		}];
																		sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																		that.$router.push({
																			name: 'FillInformation'
																		});
																	} else {
																		if(that.ticketcodelist[that.e].childidcard.length == 0) {
																			if(that.ticketcodelist[that.e].idcard == that.IdNumber) {
																				for(var i = 0; i < that.ticketcodelist.length; i++) {
																					if(that.ticketcodelist[i].childidcard.length == 0) {
																						if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else {
																							if(i == that.ticketcodelist.length - 1) {
																								var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																								that.ticketcodelist = codelist;
																								that.ticketcodelist[that.e].realname = that.name;
																								that.ticketcodelist[that.e].idcard = that.IdNumber;
																								that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																								that.ticketcodelist[that.e].telnum = that.phone;
																								that.ticketcodelist[that.e].certificate_type = certificate_type;;
																								that.ticketcodelist[that.e].childnum = that.childnum;
																								that.ticketcodelist[that.e].childidcard = [{
																										'name': that.childIdNumberNameOne,
																										'idcard': that.childIdNumberOne
																									},
																									{
																										'name': that.childIdNumberNameTwo,
																										'idcard': that.childIdNumberTwo
																									}
																								];
																								sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																								that.$router.push({
																									name: 'FillInformation'
																								});
																							}
																						}
																					} else {
																						for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																							if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else {
																								if(i == that.ticketcodelist.length - 1) {
																									var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																									that.ticketcodelist = codelist;
																									that.ticketcodelist[that.e].realname = that.name;
																									that.ticketcodelist[that.e].idcard = that.IdNumber;
																									that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																									that.ticketcodelist[that.e].telnum = that.phone;
																									that.ticketcodelist[that.e].certificate_type = certificate_type;;
																									that.ticketcodelist[that.e].childnum = that.childnum;
																									that.ticketcodelist[that.e].childidcard = [{
																											'name': that.childIdNumberNameOne,
																											'idcard': that.childIdNumberOne
																										},
																										{
																											'name': that.childIdNumberNameTwo,
																											'idcard': that.childIdNumberTwo
																										}
																									];
																									sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																									that.$router.push({
																										name: 'FillInformation'
																									});
																								}
																							}
																						}
																					}
																				}
																			} else {
																				for(var i = 0; i < that.ticketcodelist.length; i++) {
																					if(that.ticketcodelist[i].childidcard.length == 0) {
																						if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else {
																							if(i == that.ticketcodelist.length - 1) {
																								var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																								that.ticketcodelist = codelist;
																								that.ticketcodelist[that.e].realname = that.name;
																								that.ticketcodelist[that.e].idcard = that.IdNumber;
																								that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																								that.ticketcodelist[that.e].telnum = that.phone;
																								that.ticketcodelist[that.e].certificate_type = certificate_type;;
																								that.ticketcodelist[that.e].childnum = that.childnum;
																								that.ticketcodelist[that.e].childidcard = [{
																										'name': that.childIdNumberNameOne,
																										'idcard': that.childIdNumberOne
																									},
																									{
																										'name': that.childIdNumberNameTwo,
																										'idcard': that.childIdNumberTwo
																									}
																								];
																								sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																								that.$router.push({
																									name: 'FillInformation'
																								});
																							}
																						}
																					} else {
																						for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																							if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else {
																								if(i == that.ticketcodelist.length - 1) {
																									var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																									that.ticketcodelist = codelist;
																									that.ticketcodelist[that.e].realname = that.name;
																									that.ticketcodelist[that.e].idcard = that.IdNumber;
																									that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																									that.ticketcodelist[that.e].telnum = that.phone;
																									that.ticketcodelist[that.e].certificate_type = certificate_type;;
																									that.ticketcodelist[that.e].childnum = that.childnum;
																									that.ticketcodelist[that.e].childidcard = [{
																											'name': that.childIdNumberNameOne,
																											'idcard': that.childIdNumberOne
																										},
																										{
																											'name': that.childIdNumberNameTwo,
																											'idcard': that.childIdNumberTwo
																										}
																									];
																									sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																									that.$router.push({
																										name: 'FillInformation'
																									});
																								}
																							}
																						}
																					}
																				}
																			}
																		} else if(that.ticketcodelist[that.e].childidcard.length == 1) {
																			if(that.ticketcodelist[that.e].idcard == that.IdNumber) {
																				if(that.ticketcodelist[that.e].childidcard[0].idcard == that.childIdNumberOne) {
																					for(var i = 0; i < that.ticketcodelist.length; i++) {
																						if(that.ticketcodelist[i].childidcard.length == 0) {
																							if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else {
																								if(i == that.ticketcodelist.length - 1) {
																									var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																									that.ticketcodelist = codelist;
																									that.ticketcodelist[that.e].realname = that.name;
																									that.ticketcodelist[that.e].idcard = that.IdNumber;
																									that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																									that.ticketcodelist[that.e].telnum = that.phone;
																									that.ticketcodelist[that.e].certificate_type = certificate_type;;
																									that.ticketcodelist[that.e].childnum = that.childnum;
																									that.ticketcodelist[that.e].childidcard = [{
																											'name': that.childIdNumberNameOne,
																											'idcard': that.childIdNumberOne
																										},
																										{
																											'name': that.childIdNumberNameTwo,
																											'idcard': that.childIdNumberTwo
																										}
																									];
																									sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																									that.$router.push({
																										name: 'FillInformation'
																									});
																								}
																							}
																						} else {
																							for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																								if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							}
																						}
																					}
																				} else {
																					for(var i = 0; i < that.ticketcodelist.length; i++) {
																						if(that.ticketcodelist[i].childidcard.length == 0) {
																							if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else {
																								if(i == that.ticketcodelist.length - 1) {
																									var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																									that.ticketcodelist = codelist;
																									that.ticketcodelist[that.e].realname = that.name;
																									that.ticketcodelist[that.e].idcard = that.IdNumber;
																									that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																									that.ticketcodelist[that.e].telnum = that.phone;
																									that.ticketcodelist[that.e].certificate_type = certificate_type;;
																									that.ticketcodelist[that.e].childnum = that.childnum;
																									that.ticketcodelist[that.e].childidcard = [{
																											'name': that.childIdNumberNameOne,
																											'idcard': that.childIdNumberOne
																										},
																										{
																											'name': that.childIdNumberNameTwo,
																											'idcard': that.childIdNumberTwo
																										}
																									];
																									sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																									that.$router.push({
																										name: 'FillInformation'
																									});
																								}
																							}
																						} else {
																							for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																								if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							}
																						}
																					}
																				}
																				if(that.ticketcodelist[that.e].childidcard[0].idcard == that.childIdNumberOne) {
																					if(that.ticketcodelist[that.e].childidcard[1].idcard == that.childIdNumberTwo) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}, {
																							'name': that.childIdNumberNameTwo,
																							'idcard': that.childIdNumberTwo
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					} else {
																						for(var i = 0; i < that.ticketcodelist.length; i++) {
																							for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																								if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							}
																						}
																					}
																				} else {
																					if(that.ticketcodelist[that.e].childidcard[1].idcard == that.childIdNumberTwo) {
																						for(var i = 0; i < that.ticketcodelist.length; i++) {
																							for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																								if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							}
																						}
																					} else {
																						for(var i = 0; i < that.ticketcodelist.length; i++) {
																							for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																								if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							}
																						}
																					}
																				}
																			} else {
																				for(var i = 0; i < that.ticketcodelist.length; i++) {
																					if(that.ticketcodelist[i].childidcard.length == 0) {
																						if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else {
																							if(i == that.ticketcodelist.length - 1) {
																								var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																								that.ticketcodelist = codelist;
																								that.ticketcodelist[that.e].realname = that.name;
																								that.ticketcodelist[that.e].idcard = that.IdNumber;
																								that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																								that.ticketcodelist[that.e].telnum = that.phone;
																								that.ticketcodelist[that.e].certificate_type = certificate_type;;
																								that.ticketcodelist[that.e].childnum = that.childnum;
																								that.ticketcodelist[that.e].childidcard = [{
																										'name': that.childIdNumberNameOne,
																										'idcard': that.childIdNumberOne
																									},
																									{
																										'name': that.childIdNumberNameTwo,
																										'idcard': that.childIdNumberTwo
																									}
																								];
																								sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																								that.$router.push({
																									name: 'FillInformation'
																								});
																							}
																						}
																					} else {
																						for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																							if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else {
																								if(i == that.ticketcodelist.length - 1) {
																									var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																									that.ticketcodelist = codelist;
																									that.ticketcodelist[that.e].realname = that.name;
																									that.ticketcodelist[that.e].idcard = that.IdNumber;
																									that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																									that.ticketcodelist[that.e].telnum = that.phone;
																									that.ticketcodelist[that.e].certificate_type = certificate_type;;
																									that.ticketcodelist[that.e].childnum = that.childnum;
																									that.ticketcodelist[that.e].childidcard = [{
																											'name': that.childIdNumberNameOne,
																											'idcard': that.childIdNumberOne
																										},
																										{
																											'name': that.childIdNumberNameTwo,
																											'idcard': that.childIdNumberTwo
																										}
																									];
																									sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																									that.$router.push({
																										name: 'FillInformation'
																									});
																								}
																							}
																						}
																					}
																				}
																			}
																		} else {
																			if(that.ticketcodelist[that.e].idcard == that.IdNumber) {
																				if(that.ticketcodelist[that.e].childidcard[0].idcard == that.childIdNumberOne) {
																					if(that.ticketcodelist[that.e].childidcard[1].idcard == that.childIdNumberTwo) {
																						var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																						that.ticketcodelist = codelist;
																						that.ticketcodelist[that.e].realname = that.name;
																						that.ticketcodelist[that.e].idcard = that.IdNumber;
																						that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																						that.ticketcodelist[that.e].telnum = that.phone;
																						that.ticketcodelist[that.e].certificate_type = certificate_type;;
																						that.ticketcodelist[that.e].childnum = that.childnum;
																						that.ticketcodelist[that.e].childidcard = [{
																							'name': that.childIdNumberNameOne,
																							'idcard': that.childIdNumberOne
																						}, {
																							'name': that.childIdNumberNameTwo,
																							'idcard': that.childIdNumberTwo
																						}];
																						sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																						that.$router.push({
																							name: 'FillInformation'
																						});
																					} else {
																						for(var i = 0; i < that.ticketcodelist.length; i++) {
																							if(that.ticketcodelist[i].childidcard.length == 0) {
																								if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							} else {
																								for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																									if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else {
																										if(i == that.ticketcodelist.length - 1) {
																											var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																											that.ticketcodelist = codelist;
																											that.ticketcodelist[that.e].realname = that.name;
																											that.ticketcodelist[that.e].idcard = that.IdNumber;
																											that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																											that.ticketcodelist[that.e].telnum = that.phone;
																											that.ticketcodelist[that.e].certificate_type = certificate_type;;
																											that.ticketcodelist[that.e].childnum = that.childnum;
																											that.ticketcodelist[that.e].childidcard = [{
																													'name': that.childIdNumberNameOne,
																													'idcard': that.childIdNumberOne
																												},
																												{
																													'name': that.childIdNumberNameTwo,
																													'idcard': that.childIdNumberTwo
																												}
																											];
																											sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																											that.$router.push({
																												name: 'FillInformation'
																											});
																										}
																									}
																								}
																							}

																						}
																					}
																				} else {
																					if(that.ticketcodelist[that.e].childidcard[1].idcard == that.childIdNumberTwo) {
																						for(var i = 0; i < that.ticketcodelist.length; i++) {
																							if(that.ticketcodelist[i].childidcard.length == 0) {
																								if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							} else {
																								for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																									if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else {
																										if(i == that.ticketcodelist.length - 1) {
																											var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																											that.ticketcodelist = codelist;
																											that.ticketcodelist[that.e].realname = that.name;
																											that.ticketcodelist[that.e].idcard = that.IdNumber;
																											that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																											that.ticketcodelist[that.e].telnum = that.phone;
																											that.ticketcodelist[that.e].certificate_type = certificate_type;;
																											that.ticketcodelist[that.e].childnum = that.childnum;
																											that.ticketcodelist[that.e].childidcard = [{
																													'name': that.childIdNumberNameOne,
																													'idcard': that.childIdNumberOne
																												},
																												{
																													'name': that.childIdNumberNameTwo,
																													'idcard': that.childIdNumberTwo
																												}
																											];
																											sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																											that.$router.push({
																												name: 'FillInformation'
																											});
																										}
																									}
																								}
																							}

																						}
																					} else {
																						for(var i = 0; i < that.ticketcodelist.length; i++) {
																							if(that.ticketcodelist[i].childidcard.length == 0) {
																								if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																									that.yin = true;
																									that.yin_text = '您已填写信息';
																									return
																								} else {
																									if(i == that.ticketcodelist.length - 1) {
																										var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																										that.ticketcodelist = codelist;
																										that.ticketcodelist[that.e].realname = that.name;
																										that.ticketcodelist[that.e].idcard = that.IdNumber;
																										that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																										that.ticketcodelist[that.e].telnum = that.phone;
																										that.ticketcodelist[that.e].certificate_type = certificate_type;;
																										that.ticketcodelist[that.e].childnum = that.childnum;
																										that.ticketcodelist[that.e].childidcard = [{
																												'name': that.childIdNumberNameOne,
																												'idcard': that.childIdNumberOne
																											},
																											{
																												'name': that.childIdNumberNameTwo,
																												'idcard': that.childIdNumberTwo
																											}
																										];
																										sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																										that.$router.push({
																											name: 'FillInformation'
																										});
																									}
																								}
																							} else {
																								for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																									if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																										that.yin = true;
																										that.yin_text = '您已填写信息';
																										return
																									} else {
																										if(i == that.ticketcodelist.length - 1) {
																											var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																											that.ticketcodelist = codelist;
																											that.ticketcodelist[that.e].realname = that.name;
																											that.ticketcodelist[that.e].idcard = that.IdNumber;
																											that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																											that.ticketcodelist[that.e].telnum = that.phone;
																											that.ticketcodelist[that.e].certificate_type = certificate_type;;
																											that.ticketcodelist[that.e].childnum = that.childnum;
																											that.ticketcodelist[that.e].childidcard = [{
																													'name': that.childIdNumberNameOne,
																													'idcard': that.childIdNumberOne
																												},
																												{
																													'name': that.childIdNumberNameTwo,
																													'idcard': that.childIdNumberTwo
																												}
																											];
																											sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																											that.$router.push({
																												name: 'FillInformation'
																											});
																										}
																									}
																								}
																							}

																						}
																					}
																				}
																			} else {
																				for(var i = 0; i < that.ticketcodelist.length; i++) {
																					if(that.ticketcodelist[i].childidcard.length == 0) {
																						if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																							that.yin = true;
																							that.yin_text = '您已填写信息';
																							return
																						} else {
																							if(i == that.ticketcodelist.length - 1) {
																								var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																								that.ticketcodelist = codelist;
																								that.ticketcodelist[that.e].realname = that.name;
																								that.ticketcodelist[that.e].idcard = that.IdNumber;
																								that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																								that.ticketcodelist[that.e].telnum = that.phone;
																								that.ticketcodelist[that.e].certificate_type = certificate_type;;
																								that.ticketcodelist[that.e].childnum = that.childnum;
																								that.ticketcodelist[that.e].childidcard = [{
																										'name': that.childIdNumberNameOne,
																										'idcard': that.childIdNumberOne
																									},
																									{
																										'name': that.childIdNumberNameTwo,
																										'idcard': that.childIdNumberTwo
																									}
																								];
																								sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																								that.$router.push({
																									name: 'FillInformation'
																								});
																							}
																						}
																					} else {
																						for(var j = 0; j < that.ticketcodelist[i].childidcard.length; j++) {
																							if(that.IdNumber.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.IdNumber.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberOne.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else if(that.ticketcodelist[i].childidcard[j].idcard != undefined && that.childIdNumberTwo.toUpperCase() == that.ticketcodelist[i].childidcard[j].idcard.toUpperCase()) {
																								that.yin = true;
																								that.yin_text = '您已填写信息';
																								return
																							} else {
																								if(i == that.ticketcodelist.length - 1) {
																									var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
																									that.ticketcodelist = codelist;
																									that.ticketcodelist[that.e].realname = that.name;
																									that.ticketcodelist[that.e].idcard = that.IdNumber;
																									that.ticketcodelist[that.e].userstatus = res.data.userstatus;
																									that.ticketcodelist[that.e].telnum = that.phone;
																									that.ticketcodelist[that.e].certificate_type = certificate_type;;
																									that.ticketcodelist[that.e].childnum = that.childnum;
																									that.ticketcodelist[that.e].childidcard = [{
																											'name': that.childIdNumberNameOne,
																											'idcard': that.childIdNumberOne
																										},
																										{
																											'name': that.childIdNumberNameTwo,
																											'idcard': that.childIdNumberTwo
																										}
																									];
																									sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
																									that.$router.push({
																										name: 'FillInformation'
																									});
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}

															})
															.catch(function(err) {
																console.log(err);
															});
													}
												})
												.catch(function(err) {
													console.log(err);
												});
										}
									})
									.catch(function(err) {
										console.log(err);
									});

							}
						}

					}
				} else {
					if(that.e == '0') {
						that.orderid = sessionStorage.getItem("orderid");
						that.site_name = sessionStorage.getItem("site_name");
						if(!that.name_reg.test(that.name)) {
							that.yin = true;
							that.yin_text = '姓名认证错误';
						} else if(that.documentText == "港澳居民来往内地通行证"&&!/^([A-Z]\d{6,10}(\(\w{1}\))?)$/.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "台湾居民来往大陆通行证"&& !/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "护照"&&!that.IdNumber_reg.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "中国大陆身份证"&&!that.validIdCard(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的18位身份证号（不包含特殊字符、汉字,X需大写）';
					}  else if(!that.phoneReg.test(that.phone)) {
							that.yin = true;
							that.yin_text = '手机号认证错误';
						} else {
							that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.name + '&idcard=' + that.IdNumber + '&appointmenttime=' + that.appointmenttime, {

								})
								.then(function(res) {
									if(res.data.code=='A00001'){
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
										return
									}
									if(res.data.isbook == 1) {
										that.yin = true;
										that.yin_text = '您已预约当天的票';
									} else if(res.data.userstatus == 1) {
										that.yin = true;
										that.yin_text = '该用户为黑名单';
									} else {
										for(var i = 0; i < that.ticketcodelist.length; i++) {
											if(that.ticketcodelist[that.e].idcard.toUpperCase() == that.IdNumber.toUpperCase()) {
												if(i == that.ticketcodelist.length - 1) {
													var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
													that.ticketcodelist = codelist;
													that.ticketcodelist[that.e].realname = that.name;
													that.ticketcodelist[that.e].idcard = that.IdNumber;
													that.ticketcodelist[that.e].userstatus = res.data.userstatus;
													that.ticketcodelist[that.e].telnum = that.phone;
													that.ticketcodelist[that.e].certificate_type = certificate_type;;
													sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
													that.$router.push({
														name: 'FillInformation'
													});
												}
											} else {
												if(that.ticketcodelist[i].idcard != '' && that.ticketcodelist[i].idcard.toUpperCase() == that.IdNumber.toUpperCase()) {
													that.yin = true;
													that.yin_text = '您已填写信息';
													return
												} else {
													if(i == that.ticketcodelist.length - 1) {
														var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
														that.ticketcodelist = codelist;
														that.ticketcodelist[that.e].realname = that.name;
														that.ticketcodelist[that.e].idcard = that.IdNumber;
														that.ticketcodelist[that.e].userstatus = res.data.userstatus;
														that.ticketcodelist[that.e].telnum = that.phone;
														that.ticketcodelist[that.e].certificate_type = certificate_type;;
														sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
														that.$router.push({
															name: 'FillInformation'
														});
													}
												}
											}
										}
									}

								})
								.catch(function(err) {
									console.log(err);
								});
						}
					} else {
						that.orderid = sessionStorage.getItem("orderid");
						that.site_name = sessionStorage.getItem("site_name");
						if(!that.name_reg.test(that.name)) {
							that.yin = true;
							that.yin_text = '姓名认证错误';
						}else if(that.documentText == "港澳居民来往内地通行证"&&!/^([A-Z]\d{6,10}(\(\w{1}\))?)$/.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					} else if(that.documentText == "台湾居民来往大陆通行证"&& !/^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					}else if(that.documentText == "护照"&&!that.IdNumber_reg.test(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的证件号（不包含特殊字符、汉字）';
					}  else if(that.documentText == "中国大陆身份证"&&!that.validIdCard(that.IdNumber)) {
						that.yin = true;
						that.yin_text = '请输入正确的18位身份证号（不包含特殊字符、汉字,X需大写）';
					}  else {
							that.$http.get(that.baseUrl + '/tickets/tickets/ajax?ugi=bookingticket&action=checkticketInfo&moduleid=TICKETS&taid=' + that.taid + '&paragraphid=' + that.paragraphid + '&bind_telnum=' + that.phone + '&bind_realname=' + that.name + '&idcard=' + that.IdNumber + '&appointmenttime=' + that.appointmenttime, {

								})
								.then(function(res) {
									if(res.data.code=='A00001'){
										that.yin = true;
										that.yin_text = '系统繁忙，请稍后再试';
										return
									}
									if(res.data.isbook == 1) {
										that.yin = true;
										that.yin_text = '您已预约当天的票';
									} else if(res.data.userstatus == 1) {
										that.yin = true;
										that.yin_text = '该用户为黑名单';
									} else {
										for(var i = 0; i < that.ticketcodelist.length; i++) {
											if(that.ticketcodelist[that.e].idcard.toUpperCase() == that.IdNumber.toUpperCase()) {
												if(i == that.ticketcodelist.length - 1) {
													var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
													that.ticketcodelist = codelist;
													that.ticketcodelist[that.e].realname = that.name;
													that.ticketcodelist[that.e].idcard = that.IdNumber;
													that.ticketcodelist[that.e].userstatus = res.data.userstatus;
													that.ticketcodelist[that.e].telnum = that.phone;
													that.ticketcodelist[that.e].certificate_type = certificate_type;;
													sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
													that.$router.push({
														name: 'FillInformation'
													});
												}
											} else {
												if(that.ticketcodelist[i].idcard != '' && that.ticketcodelist[i].idcard.toUpperCase() == that.IdNumber.toUpperCase()) {
													that.yin = true;
													that.yin_text = '您已填写信息';
													return
												} else {
													if(i == that.ticketcodelist.length - 1) {
														var codelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
														that.ticketcodelist = codelist;
														that.ticketcodelist[that.e].realname = that.name;
														that.ticketcodelist[that.e].idcard = that.IdNumber;
														that.ticketcodelist[that.e].userstatus = res.data.userstatus;
														that.ticketcodelist[that.e].telnum = that.phone;
														that.ticketcodelist[that.e].certificate_type = certificate_type;;
														sessionStorage.setItem("ticketcodelist", JSON.stringify(that.ticketcodelist));
														that.$router.push({
															name: 'FillInformation'
														});
													}
												}
											}
										}
									}

								})
								.catch(function(err) {
									console.log(err);
								});
						}
					}
				}
			},
			modify() {
				var that = this;
				that.yin = false;
			},
			modify() {
				var that = this;
				that.yin = false;
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.e = sessionStorage.getItem("e");
			that.taid = sessionStorage.getItem("taid");
			that.orderType = sessionStorage.getItem("orderType");
			that.appointmenttime = sessionStorage.getItem("appointmenttime");
			that.site_name = sessionStorage.getItem("site_name");
			that.paragraphid = sessionStorage.getItem("paragraphid");
			that.phoneReg = /^1[3456789]\d{9}$/;
			that.ticketcodelist = $.parseJSON(sessionStorage.getItem("ticketcodelist"));
			that.name = that.ticketcodelist[that.e].realname;
			that.IdNumber = that.ticketcodelist[that.e].idcard;
			that.childnum = that.ticketcodelist[that.e].childnum;
			if(that.childnum == '') {
				that.childnum = '请选择携带儿童数量'
			} else if(that.childnum == '1') {
				that.childIdNumberNameOne = that.ticketcodelist[that.e].childidcard[0].name;
				that.childIdNumberOne = that.ticketcodelist[that.e].childidcard[0].idcard;
			} else if(that.childnum == '2') {
				that.childIdNumberNameOne = that.ticketcodelist[that.e].childidcard[0].name;
				that.childIdNumberOne = that.ticketcodelist[that.e].childidcard[0].idcard;
				that.childIdNumberNameTwo = that.ticketcodelist[that.e].childidcard[1].name;
				that.childIdNumberTwo = that.ticketcodelist[that.e].childidcard[1].idcard;
			}
			that.phone = that.ticketcodelist[that.e].telnum;
						if(that.ticketcodelist[that.e].certificate_type=='idcard'){
							that.documentText='中国大陆身份证'
						}else{
							that.documentText = that.ticketcodelist[that.e].certificate_type;
						}
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}
			}
		}
	}
</script>

<style scoped>
	body {
		width: 100%;
		height: 100vh;
		background: #eee !important;
		overflow: hidden;
	}
	
	.information {
		width: 80%;
		background: #fff;
		border-radius: 15px;
		overflow: hidden;
		padding: 0 5%;
		margin: 0 auto;
		margin-top: 4%;
		-webkit-overflow-scrolling: touch;
	}
	
	.information_child {
		width: 80%;
		background: #fff;
		border-radius: 15px;
		overflow: hidden;
		padding: 0 5%;
		margin: 0 auto;
		margin-top: 4%;
		-webkit-overflow-scrolling: touch;
	}
	
	.img_gr {
		width: 22px;
	}
	
	.img_sfz {
		width: 22px;
	}
	
	.img_sjh {
		width: 16px;
	}
	
	.information_div {
		display: flex;
		margin-top: 16px;
		padding-bottom: 16px;
		border-bottom: 1px #eee solid;
		align-items: center;
	}
	
	.information_div_div {
		width: 30px;
		margin-right: 30px;
		justify-content: center;
	}
	
	input {
		border: none;
		outline: none;
		height: 35px;
		font-size: 16px;
	}
	
	select {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 16px;
		color: #B1B1B1;
		width: 72%;
		background: white !important;
	}
	
	.information_div>img {
		width: 5%;
	}
	
	.buttom_bc {
		width: 60%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 39px;
		border-radius: 48px;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		margin: 15px auto;
	}
	
	.view_yinyin {
		width: 100vh;
		height: 100vh;
		background: rgba(0, 0, 0, .3);
		position: fixed;
		top: 0;
		overflow: hidden
	}
	
	.yin_ts {
		position: fixed;
		top: 25%;
		background: #fff;
		z-index: 999;
		border-radius: 20px;
		width: 66%;
		left: 17%;
		text-align: center;
	}
	
	.buttom_x {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px 0;
	}
	
	.buttom_x img {
		width: 60px;
	}
	
	.text {
		font-size: 17px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(55, 55, 55, 1);
		width: 80%;
		margin: 0 auto;
	}
	
	.title {
		font-weight: 400;
		color: rgba(164, 164, 164, 1);
		font-size: 16px;
		line-height: 30px;
		border-bottom: 1px rgb(225, 225, 225) solid;
		padding-bottom: 10px;
	}
	
	.buttom_text {
		color: rgba(228, 4, 4, 1);
		line-height: 50px;
		font-size: 16px;
		font-weight: bold;
		margin-top: 20px;
		border-top: 1px solid #eee;
	}
	
	.childnum {
		width: 20%;
	}
	
	.fill_btn_bottom {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
	}
	
	.information_container {
		width: 100%;
		padding-bottom: 80px;
	}
</style>


// WEBPACK FOOTER //
// src/components/information.vue